import React from 'react';
import { Avatar, Box, Stack, Tooltip } from '@mui/material';
import { theme } from '../../../../common/styles/theme';

export const AVATAR_NAME_TEXT_CLASS = 'avatar-name__text';

// true when the name inside el is cut by the ellipsis
export const isAvatarNameTruncated = (el: Element) => {
	const text = el.querySelector(`.${AVATAR_NAME_TEXT_CLASS}`);
	return !!text && text.scrollWidth > text.clientWidth;
};

export const AvatarName: React.FC<{
	name: string;
	picture?: string;
	size?: number; // theme.spacing units
	avatarOnly?: boolean; // name goes to a tooltip instead
}> = ({ name, picture, size = 2.5, avatarOnly }) => {
	const avatar = (
		<Avatar
			src={picture}
			alt={name}
			sx={{
				width: theme.spacing(size),
				height: theme.spacing(size),
				flexShrink: 0,
				fontSize: `calc(${theme.spacing(size)} / 2)`,
			}}
		>
			{name?.charAt(0).toUpperCase()}
		</Avatar>
	);

	if (avatarOnly) {
		return (
			<Tooltip
				title={name}
				placement={'top'}
				enterDelay={500}
				disableInteractive
			>
				{avatar}
			</Tooltip>
		);
	}

	return (
		<Stack
			direction={'row'}
			gap={.75}
			alignItems={'center'}
			sx={{
				minWidth: 0,
			}}
		>
			{avatar}
			<Box
				className={AVATAR_NAME_TEXT_CLASS}
				sx={{
					minWidth: 0,
					lineHeight: 1.4,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}}
			>
				{name}
			</Box>
		</Stack>
	);
};
